
<template>
  <div class="study" :class="{ isIosx: isIosx }">
    <van-sticky :z-index="9999">
      <div class="studyNav">
        <span class="navTitle">学习中心</span>
        <span class="navRight" @click="setStudy()">管理</span>
      </div>
    </van-sticky>
    <div class="studyContent">
      <van-tabs
        v-model="active"
        line-width="16px"
        line-height="4px"
        title-inactive-color="#6E727A"
        title-active-color="#404247"
        @change="tabChange"
      >
        <van-tab
          :title="item.title"
          v-for="(item, index) in navList"
          :key="index"
        >
          <div v-if="loaded">
            <div v-if="studyList.length > 0">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" @load="onLoad">
                  <div class="studyContentMid">
                    <CourseColum
                      :dataList="studyList"
                      :isSet="isSet"
                      :isStudy="true"
                      @check="check"
                      @unCheck="unCheck"
                    ></CourseColum>
                  </div>
                </van-list>
              </van-pull-refresh>
            </div>
            <div v-else class="noStudy">
              <img src="./../../assets/school/studyTip.png" />
              <p>暂无学习计划</p>
            </div>
          </div>
          <div v-else class="studyload">
            <img src="./../../assets/school/loading.gif" />
            <p>加载中</p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="studyRecommend" v-if="recommendList.length > 0">
      <h3>
        <img src="./../../assets/school/courseLeft.png" />
        <span>课程推荐</span>
        <img src="./../../assets/school/courseRight.png" />
      </h3>
      <CourseRow :dataList="recommendList"></CourseRow>
      <div class="btm_tip">
        <p>没有更多了</p>
      </div>
    </div>
    <!-- 选择课程底部操作框 -->
    <div class="setBtm" v-if="isSet">
      <div @click="allCheck()">
        <img src="./../../assets/school/check.png" v-if="isCheck" />
        <img src="./../../assets/school/unselected1.png" v-else />
        全选
      </div>
      <div>
        <span @click="del()">移除({{ this.delList.length }})</span>
      </div>
    </div>
  </div>
</template>

<script>
import CourseColum from "./components/courseColumn.vue";
import CourseRow from "./components/courseRow.vue";
export default {
  data() {
    return {
      isIosx: false,
      loaded: false,
      active: 0,
      type: 0,
      isSet: false, //是否开始选择课程
      page: 1,
      pageSize: 10,
      navList: [
        { title: "全部", value: 0 },
        { title: "图文", value: 3 },
        { title: "视频", value: 2 },
        { title: "音频", value: 4 },
        { title: "专栏", value: 1 },
      ],
      isCheck: false,
      delList: [],
      studyList: [],
      recommendList: [],
      refreshing: false,
      loading: false,
      finished: false,
    };
  },
  components: { CourseColum, CourseRow },
  mounted() {
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.isIosx = this.isIphoneX();
    this.getData();
    this.getRecommendData();
  },
  activated() {
    setTimeout(() => {
      this.onRefresh();
    }, 100);
  },
  methods: {
    // 管理学习课程
    setStudy() {
      this.isSet = !this.isSet;
    },
    // tab切换
    tabChange(name, title) {
      this.type = this.navList[name].value;
      this.isSet = false;
      this.isCheck = false;
      this.delList = [];
      this.onRefresh();
      this.loaded = false;
    },
    // 获取数据
    getData() {
      this.$api
        .post("school/member/study/list", {
          type: this.type, //类型：Number  必有字段  备注：1专栏 ，2:单视频，3图文，4音频
          page: this.page, //类型：Number  必有字段  备注：无
          pageSize: this.pageSize, //类型：Number  必有字段  备注：无
        })
        .then((res) => {
          // this.studyList = res.list;
          this.studyList = this.studyList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.studyList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.studyList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    // 获取推荐课程
    getRecommendData() {
      this.$api.get("school/member/study/center/recommend").then((res) => {
        this.recommendList = res.list;
      });
    },
    // 全选
    allCheck() {
      this.isCheck = !this.isCheck;
      this.delList = [];
      if (this.isCheck) {
        // 全选
        this.studyList.forEach((item) => {
          item.check = true;
          this.delList.push(item.id);
        });
      } else {
        // 不全选
        this.studyList.forEach((item) => {
          item.check = false;
        });
      }
      this.studyList = [...this.studyList];
    },
    // 选择
    check(item) {
      item.check = true;
      this.delList.push(item.id);
      this.studyList = [...this.studyList];
    },
    // 取消选择
    unCheck(item) {
      item.check = false;
      if (this.delList.indexOf(item.id) > -1) {
        this.delList.splice(this.delList.indexOf(item.id), 1);
      }
      this.studyList = [...this.studyList];
    },
    // 移除
    del() {
      this.$api
        .post("school/member/cancel/study", {
          courses_ids: this.delList,
        })
        .then((res) => {
          this.$toast("移除成功！");
          this.isSet = false;
          this.delList = [];
          this.onRefresh();
        });
    },
  },
};
</script>

<style>
.studyload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.studyload img {
  width: 80px;
  height: 80px;
  margin: 20px 0 0;
}
.studyload p {
  font-size: 12px;
  color: #9ca1ad;
}
.study {
  height: 100%;
  background: #f7f8fc;
  /* overflow: auto; */
}
.studyNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.studyNav .navTitle {
  font-size: 17px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.studyNav .navRight {
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  right: 16px;
  margin-top: 2px;
}
/* content */
.studyContent .studyContentMid {
  padding: 27px 16px;
  background-color: #ffffff;
}
.van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
  bottom: 19px;
}
.study .van-tab {
  flex: 1;
  font-size: 15px;
}
.study .van-tab--active {
  font-weight: 700;
}

/* 推荐 */
.studyRecommend {
  background-color: #f7f8fc;
  padding: 16px 16px 60px;
}
.studyRecommend > h3 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #404247;
  font-size: 14px;
  margin: 0 0 16px 0;
}
.studyRecommend > h3 span {
  margin: 0 4px;
}
.studyRecommend > h3 img {
  width: 20px;
  height: 20px;
}
.studyRecommend .btm_tip {
  display: flex;
  justify-content: center;
}
.studyRecommend .btm_tip p {
  font-size: 14px;
  font-weight: 400;
  color: #9ca1ad;
  line-height: 20px;
  text-align: center;
  margin: 32px 0;
}
/* 底部操作框 */
.setBtm {
  width: 100%;
  height: 46px;
  background-color: #ffffff;
  position: fixed;
  left: 0;
  bottom: 50px;
  z-index: 999;
  box-shadow: 0px 1px 0px 0px #ffffff, 0px 1px 0px 0px #f7f8fc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.setBtm > div {
  margin: 0 16px;
  color: #404247;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.setBtm > div img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.setBtm > div span {
  width: 80px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  background-color: rgba(78, 125, 247, 0.1);
  color: #4e7df7;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  border-radius: 16px;
}

.isIosx .studyNav {
  padding-top: 44px;
}
.isIosx .setBtm {
  bottom: 84px;
}
.isIosx .studyRecommend {
  padding: 16px 16px 94px;
}

.noStudy {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: 32px 16px;
}
.noStudy img {
  width: 155px;
  height: 90px;
}
.noStudy p {
  margin-top: 12px;
  font-size: 14px;
  color: #9ca1ad;
}
</style>